import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { useSubscription } from '../../../hooks/subscription';
import { useSubscriptionPopup } from '../../../hooks/subscriptionPopup';
import { SubscriptionPopup } from '../../IdleSubscriptionPopup/components/SubscriptionPopup';
import styles from '../left-column.module.scss';

interface SubscriptionLinkProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const SubscriptionLink = ({ subscriptionPopupState }: SubscriptionLinkProps) => {
  const { userEmail, handleSubscriptionClick, canUserSubscribe, isEmailEditable } = useSubscription('Попап');
  const [isVisible, setIsVisible] = useBoolean();

  const { onVisible, onHide } = useSubscriptionPopup(subscriptionPopupState);

  if (!canUserSubscribe) return null;

  return (
    <>
      <Typography.Text size={12} className={styles.bottomLink}>
        <Typography.Link color={'dark'} onClick={setIsVisible.on}>
          Подписаться на рассылку
        </Typography.Link>
      </Typography.Text>
      <SubscriptionPopup
        userEmail={userEmail}
        onSubscribe={handleSubscriptionClick}
        onVisible={onVisible}
        onHide={onHide}
        canBeVisible={isVisible}
        onClose={setIsVisible.off}
        isEmailEditable={isEmailEditable}
      />
    </>
  );
};
